import React from 'react';
import "./csss/InformationPages.css";

export default function Updates() {
    return <div>
        <div className="container-doc">
            <div style={{fontFamily: 'Source_Sans3_bold', textAlign: "center", fontSize: "40px"}}>Обновления</div><br/>

            <div className="h2">2.1.1 — Больше удобства (latest)</div>
            <div className="subInfo">Дата релиза: 18.12.2025</div><br/>
            <div className="h3">Изменения:</div>
            <ul>
                <li>При открытии файла за год будет автоматически открываться текущий период</li>
                <li>Исправлены мелкие баги</li>
            </ul>

            <br/><br/>
            <div className="h2">2.1.0 — Крупное обновление</div>
            <div className="subInfo">Дата релиза: 14.12.2025</div><br/>
            <div className="h3">Изменения:</div>
            <ul>
                <li>Файл за весь год теперь анализируется по-другому: появились вкладки по всем периодам за весь год
                    и не нужно отдельно загружать файлы за эти периоды, получается вместо 5 файлов — 1</li>
                <li>Во вкладке "Год" годового файла представлена таблица со всеми итоговыми оценками за все периоды, а также годовые оценки</li>
                <li>В блоке, где представлены предметы и средние баллы по ним появилась сортировка по алфавиту,
                    по баллам, по количеству оценок. Для этого нужно нажать на соответствующее слово (балл, предмет или количество)</li>
                <li>Добавлена текущая страница про обновления</li>
            </ul>

            <br/><br/>
            <div className="h2">2.0.1-2.0.10 — Исправления багов</div>
            <div className="subInfo">Подробная информация об этих версиях не зафиксирована по причине отсутствия данной
                страницы до версии 2.1.0</div>


            <br/><br/>
            <div className="h2">2.0.0 — Первый релиз</div>
            <div className="subInfo">Дата релиза: 31.10.2025</div>
        </div>
    </div>
};